<template>
    <div class="row">
        <div class="col-xs-4 col-xs-offset-4">
            <div class="fa-stack fa-4x pincode-lock">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-lock fa-stack-1x fa-inverse"></i>
            </div>

            <h3 class="text-center">
                Enter your PIN code
            </h3>

            <div class="text-center pincode-input-display">
                <i v-for="i in count" :class="['fa', inputLength >= i ? 'fa-circle' : 'fa-circle-o']"></i>
            </div>

            <div class="pincode-buttons">
                <div v-for="i in values" class="pincode-button">
                    <button @click="onClick(i)">
                        {{ i }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            count: {
                type: Number,
                default: 4
            }
        },
        computed: {
            values() {
                let inputs = _.range(1, 10)
                inputs.push('Cancel', 0, 'Reset')
                return inputs
            },
            inputLength() {
                if (this.input) {
                    return this.input.length
                }

                return 0;
            }
        },
        watch: {
            input(value) {
                if (value.length !== this.count)
                    return

                this.$emit('submit', value)
            }
        },
        methods: {
            onClick(btn) {
                if (isNaN(btn)) {
                    this.input = ''
                    if (btn === 'Cancel') {
                        this.$emit('pincode-cancel')
                    }

                    return
                }

                this.onInput(btn)
            },
            onInput(v) {
                this.input += v
            },
            onReset() {
                this.input = ''
            }
        },
        data() {
            return {
                input: '',
            };
        },
        created() {
            window.addEventListener('keyup', e => {
                if (isNaN(e.key))
                    return;

                this.onInput(e.key)
            });
        }
    }
</script>

<style lang="scss">

    div.pincode-buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        & .pincode-button {
            flex: 1 0 33%;
            margin-top: 1em;
            text-align: center;
        }

        & button {
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;

            outline: none;
            height: 100px;
            width: 100px;
            box-sizing: border-box;
            padding: 1em;
            border-radius: 50%;

            &:hover, &:active {
                border: 1px solid #333;
            }
        }
    }

    .pincode-lock {
        display: block;
        margin: 0 auto;
        /*font-size: 3em;*/

        & i:first-child {
            color: #0d4e81;
        }
    }

    div.pincode-input-display {
        margin-top: 2em;
        margin-bottom: 2em;
        text-align: center;

        & i {
            font-size: 2.5em;
        }

        & i:not(:last-child) {
            margin-right: 1em;
        }
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Login/PinCodeInput.vue